import { h } from "preact";
import { useSelector } from "react-redux";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";

import AppFooter from "../components/AppFooter.jsx";
import AppHeader from "../components/AppHeader.jsx";
import AppLayout from "../components/AppLayout.jsx";
import ProfileDetails from "../components/ProfileDetails.jsx";

import i18n from "../i18n.js";
import { selectCurrentUser } from "../store/index";

export default function ProfilePage(props) {
  const user = useSelector(selectCurrentUser);

  if (!user) {
    window.location.href = "/login";
    return;
  }

  return (
    <AppLayout
      ornamented
      header={<AppHeader title={i18n.t("pages.titles.profile")} />}
      footer={<AppFooter />}
    >
      <ProfileDetails />
    </AppLayout>
  );
}
